import { Reveal, Overline } from "./Reveal";
import { SERVICES } from "./data";
import { Home, ArrowUpRight } from "lucide-react";

export const Services = () => (
  <section id="leistungen" className="relative bg-white text-[#111] py-24 sm:py-36" data-testid="services">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
        <Reveal>
          <Overline className="text-neutral-500">02 — Leistungen</Overline>
          <h2 className="mt-4 font-grotesk font-medium text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
            Vier Therapien. <span className="text-neutral-400">Ein Ort — Ihr Zuhause.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <span className="inline-flex items-center gap-2 font-grotesk text-sm text-[var(--pmr-red)] border border-[var(--pmr-red)]/30 rounded-full px-4 py-2">
            <Home size={15} /> Alle Leistungen nur als Hausbesuch
          </span>
        </Reveal>
      </div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
        {SERVICES.map((s, i) => (
          <Reveal key={s.id} delay={i * 0.08}>
            <article
              className="group relative overflow-hidden rounded-sm border border-neutral-200 bg-white transition-colors hover:border-neutral-300"
              data-testid={`service-card-${s.id}`}
            >
              <div className="overflow-hidden">
                <img src={s.img} alt={s.title}
                  className="w-full h-56 sm:h-64 object-cover grayscale-[25%] group-hover:grayscale-0 group-hover:scale-105 transition-[transform,filter] duration-700" />
              </div>
              <div className="p-7 sm:p-9">
                <div className="flex items-center justify-between">
                  <span className="font-display font-black text-3xl silver-text-dark">{s.num}</span>
                  <span className="font-grotesk text-[11px] tracking-[0.2em] uppercase text-neutral-400">{s.tag}</span>
                </div>
                <h3 className="mt-4 font-grotesk font-bold text-2xl flex items-center gap-2">
                  {s.title}
                  <ArrowUpRight size={20} className="text-[var(--pmr-red)] opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
                </h3>
                <p className="mt-3 font-body text-[15px] text-neutral-600 leading-relaxed">{s.text}</p>
              </div>
              <span className="absolute bottom-0 left-0 h-1 w-0 bg-[var(--pmr-red)] group-hover:w-full transition-[width] duration-500" />
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
